import "./header.css";

const Header = ({ children }) => {
    return (<header>
        {children}
    </header>);
}
export default Header;